import styled from 'styled-components';

interface TabProps {
  active?: boolean;
}

export const Container = styled.div``;

export const Header = styled.div`
  display: flex;
  transform: translateY(1px);
  gap: 15px;
`;

export const Tab = styled.div<TabProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 0 15px;
  padding-bottom: 10px;

  font-weight: ${(props) => props.active && '500'};
  color: ${(props) =>
    props.active ? props.theme.colors.darkGray : props.theme.colors.gray};

  border-bottom: ${(props) =>
    props.active
      ? `3px solid ${props.theme.colors.primary}`
      : '3px solid transparent'};
  color: ${(props) =>
    props.active ? props.theme.colors.text : props.theme.colors.opacityText};

  label {
    pointer-events: none;
    font-weight: 600;
  }
`;

export const Content = styled.div`
  border-radius: 3px;
  border-top: 1px solid ${(props) => props.theme.colors.inputBorder};
  padding-top: 15px;

  display: flex;
  align-self: flex-start;

  @media (max-width: 975px) {
    padding: 25px 15px 15px 15px;
  }
`;
